import http from '../../http/base';
import { API_PATHS } from '../../http/configs';

export function getStatesList() {
    return http.get(API_PATHS.listStates);
}
